export const GET_DISCUSSION = "GET_DISCUSSION";
export const GET_DISCUSSION_BY_ASPIRATION_ID =
  "GET_DISCUSSION_BY_ASPIRATION_ID";
export const DISCUSSION_ERROR = "DISCUSSION_ERROR";
export const POST_DISCUSSION = "POST_DISCUSSION";
